import { createPermission } from '@backstage/plugin-permission-common';

// Permissions « de base » (sans environnement). Aucun backend ne les vérifie :
// elles ne servent qu'à masquer des boutons de l'interface, et `policy.csv`
// ne les accorde à personne — ces boutons sont donc masqués pour TOUS, défaut
// connu depuis la phase 1 et laissé en l'état. Depuis la phase 5, chacune est
// DÉCLARÉE par le backend du module qui porte l'action : elle disparaît de
// « Accès & rôles » avec lui.
export const serviceRestartPermission = createPermission({
  name: 'platform.service.restart',
  attributes: { action: 'update' },
});

export const serviceRollbackPermission = createPermission({
  name: 'platform.argocd.rollback',
  attributes: { action: 'update' },
});

export const dbDumpPermission = createPermission({
  name: 'platform.db.dump',
  attributes: { action: 'read' },
});

export const serviceCacheClearPermission = createPermission({
  name: 'platform.service.cache-clear',
  attributes: { action: 'update' },
});

// platform.env.edit n'existe plus (phase 5, tâche 2bis) : permission morte à 100 % —
// aucun backend ne la vérifiait, aucune interface ne la lisait, `policy.csv`
// ne l'accordait à personne (inventaire de la phase 1). Elle n'était que du
// bruit dans « Accès & rôles ». Sa variante par environnement, elle, vit.

export const cronjobManagePermission = createPermission({
  name: 'platform.cronjob.manage',
  attributes: { action: 'update' },
});

// platform.db.backup n'existe plus (phase 5, tâche 2bis) : permission morte à 100 % —
// aucun backend ne la vérifiait, aucune interface ne la lisait, `policy.csv`
// ne l'accordait à personne (inventaire de la phase 1). Elle n'était que du
// bruit dans « Accès & rôles ». Sa variante par environnement, elle, vit.

// keycloakAdminPermission n'est plus déclarée ici : keycloak-admin-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-keycloak-admin-common (phase 1, tâche 2 — même geste que
// platform.cost.read en tâche 1).

// cacheManagePermission n'est plus déclarée ici : elle vit dans
// @platform/plugin-cache-common avec ses variantes par environnement, et
// cache-backend la déclare (phase 5, tâche 2bis).

export const agentAdminPermission = createPermission({
  name: 'platform.agent.admin',
  attributes: { action: 'update' },
});

// platform.pipeline.manage n'existe plus (phase 5, tâche 2bis) : permission morte à 100 % —
// aucun backend ne la vérifiait, aucune interface ne la lisait, `policy.csv`
// ne l'accordait à personne (inventaire de la phase 1). Elle n'était que du
// bruit dans « Accès & rôles ». Sa variante par environnement, elle, vit.

export const k8sReadPermission = createPermission({
  name: 'platform.k8s.read',
  attributes: { action: 'read' },
});

// platform.terminal.access n'existe plus (phase 5, tâche 2bis) : permission morte à 100 % —
// aucun backend ne la vérifiait, aucune interface ne la lisait, `policy.csv`
// ne l'accordait à personne (inventaire de la phase 1). Elle n'était que du
// bruit dans « Accès & rôles ». Sa variante par environnement, elle, vit.

// pipelineReadPermission n'est plus déclarée ici : gitlab-ci-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-gitlab-ci-common / plugin-argocd-common (chantier 1, tâche 2).

// insightsReadPermission / insightsManagePermission ne sont plus déclarées
// ici : ai-insights-backend les déclare lui-même
// (createPermissionIntegrationRouter) depuis @platform/plugin-ai-insights-common
// (phase 1, tâche 2).

// Env-scoped permissions — preprod
export const serviceRestartPreprodPermission = createPermission({
  name: 'platform.service.restart.preprod',
  attributes: { action: 'update' },
});

// serviceRollbackPreprodPermission n'est plus déclarée ici : argocd-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-gitlab-ci-common / plugin-argocd-common (chantier 1, tâche 2).

// envManagerEditPreprodPermission n'est plus déclarée ici : env-manager-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-env-manager-common (phase 1, tâche 2).

export const cronjobManagePreprodPermission = createPermission({
  name: 'platform.cronjob.manage.preprod',
  attributes: { action: 'update' },
});

export const dbBackupManagePreprodPermission = createPermission({
  name: 'platform.db.backup.preprod',
  attributes: { action: 'update' },
});

export const dbDumpPreprodPermission = createPermission({
  name: 'platform.db.dump.preprod',
  attributes: { action: 'read' },
});

export const serviceCacheClearPreprodPermission = createPermission({
  name: 'platform.service.cache-clear.preprod',
  attributes: { action: 'update' },
});

// cacheManagePreprodPermission n'est plus déclarée ici : cache-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-cache-common (phase 1, tâche 2).

// pipelineManagePreprodPermission n'est plus déclarée ici : gitlab-ci-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-gitlab-ci-common / plugin-argocd-common (chantier 1, tâche 2).

// terminalAccessPreprodPermission n'est plus déclarée ici : agent-router-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-agent-router-common (phase 1, tâche 2).

// Env-scoped permissions — staging
export const serviceRestartStagingPermission = createPermission({
  name: 'platform.service.restart.staging',
  attributes: { action: 'update' },
});

export const cronjobManageStagingPermission = createPermission({
  name: 'platform.cronjob.manage.staging',
  attributes: { action: 'update' },
});

export const dbBackupManageStagingPermission = createPermission({
  name: 'platform.db.backup.staging',
  attributes: { action: 'update' },
});

export const dbDumpStagingPermission = createPermission({
  name: 'platform.db.dump.staging',
  attributes: { action: 'read' },
});

export const serviceCacheClearStagingPermission = createPermission({
  name: 'platform.service.cache-clear.staging',
  attributes: { action: 'update' },
});

// Les variantes .staging de rollback, env.edit, cache.manage, pipeline.manage et
// terminal.access suivent leurs homologues .preprod : déclarées par le module
// propriétaire (cache.manage.staging : nom seul, sans propriétaire).

// Env-scoped permissions — prod
export const serviceRestartProdPermission = createPermission({
  name: 'platform.service.restart.prod',
  attributes: { action: 'update' },
});

// serviceRollbackProdPermission n'est plus déclarée ici : argocd-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-gitlab-ci-common / plugin-argocd-common (chantier 1, tâche 2).

// envManagerEditProdPermission n'est plus déclarée ici : env-manager-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-env-manager-common (phase 1, tâche 2).

export const cronjobManageProdPermission = createPermission({
  name: 'platform.cronjob.manage.prod',
  attributes: { action: 'update' },
});

export const dbBackupManageProdPermission = createPermission({
  name: 'platform.db.backup.prod',
  attributes: { action: 'update' },
});

export const dbDumpProdPermission = createPermission({
  name: 'platform.db.dump.prod',
  attributes: { action: 'read' },
});

export const serviceCacheClearProdPermission = createPermission({
  name: 'platform.service.cache-clear.prod',
  attributes: { action: 'update' },
});

// cacheManageProdPermission n'est plus déclarée ici : cache-backend la déclare
// lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-cache-common (phase 1, tâche 2).

// pipelineManageProdPermission n'est plus déclarée ici : gitlab-ci-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-gitlab-ci-common / plugin-argocd-common (chantier 1, tâche 2).

// terminalAccessProdPermission n'est plus déclarée ici : agent-router-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-agent-router-common (phase 1, tâche 2).

// monitoringReadPermission n'est plus déclarée ici : monitoring-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-monitoring-common (phase 1, tâche 2).

// aiObservabilityReadPermission n'est plus déclarée ici : ai-observability-backend
// la déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-ai-observability-common (phase 1, tâche 2).

export const doraReadPermission = createPermission({
  name: 'platform.dora.read',
  attributes: { action: 'read' },
});

// securityReadPermission n'est plus déclarée ici : security-insights-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-security-insights-common (phase 1, tâche 2).

// costReadPermission n'est plus réexportée ici : cost-backend la déclare lui-même
// (createPermissionIntegrationRouter) depuis @platform/plugin-cost-common. La retirer
// d'ici la retire du même coup de ALL_PLATFORM_PERMISSIONS (roles.ts, dérivée par
// Object.values(allPerms) de ce module) — c'est la preuve de la tâche 1 : le module
// porte sa propre déclaration, le registre central ne la double plus.

// llmGatewayReadPermission / llmGatewayManagePermission ne sont plus déclarées
// ici : llm-gateway-backend les déclare lui-même
// (createPermissionIntegrationRouter) depuis @platform/plugin-llm-gateway-common
// (phase 1, tâche 2).

// previewManagePermission / previewAgentPermission / previewCreatePermission ne
// sont plus déclarées ici : preview-env-backend les déclare lui-même
// (createPermissionIntegrationRouter) depuis @platform/plugin-preview-env-common
// (phase 1, tâche 2).

// incidentManagePermission n'est plus déclarée ici : incidents-backend la
// déclare lui-même (createPermissionIntegrationRouter) depuis
// @platform/plugin-incidents-common (phase 1, tâche 2).

